import React from 'react';
import { Form, Input, Select } from 'antd';
import { checkNumber, conditionCheckNumber } from 'util/validators';

const { Option } = Select;

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: this.props.isEditable || false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.isReset !== prevProps.isReset) {
      this.form.resetFields();
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (key, inputValue = '') => {
    const { record, handleSave, handleError, isEditable } = this.props;
    const value = inputValue || this.form.getFieldValue(key);

    if (key === 'brand') {
      if (!value) {
        handleError(true);
        return;
      }
    }

    if (key === 'value') {
      if (!conditionCheckNumber(value)) {
        handleError(true);
        return;
      }
    }

    if (!isEditable) {
      this.toggleEdit();
    }

    handleError(false);
    handleSave({ ...record, [key]: value });
  };

  renderCell = form => {
    this.form = form;
    const { children, dataIndex, record, title, categories, industries, loadingCategory, loadingIndustry } = this.props;
    const { editing } = this.state;
    const indexField = `${dataIndex}_${record.key}`;
    let formItem = <Form.Item style={{ margin: 0 }}>
    {form.getFieldDecorator(indexField, {
      initialValue: record[indexField],
      rules: dataIndex === 'value' ? [{ validator: checkNumber }] : [{ required: true, message: 'Dữ liệu bắt buộc' }],
    })(<Input style={{ width: 200 }} placeholder={title} onChange={e => this.save(dataIndex, e.target.value)} ref={node => (this.input = node)} />)}
  </Form.Item>

    if (dataIndex === 'industry') {
      formItem = <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(indexField, {
          initialValue: [],
        })(<Select loading={loadingIndustry} optionFilterProp="children" showSearch filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
        } placeholder='Chọn Industry' ref={node => (this.input = node)} style={{ width: 200 }} onChange={e => this.save(dataIndex, e)}>
          {industries.map(industry => <Option key={`industry_${industry.key}`} value={industry.name}>{industry.name}</Option>)}
        </Select>)}
      </Form.Item>
    }

    if (dataIndex === 'category') {
      formItem = <Form.Item style={{ margin: 0 }}>
      {form.getFieldDecorator(indexField, {
        initialValue: [],
      })(
        <Select loading={loadingCategory} showSearch placeholder='Chọn Category' ref={node => (this.input = node)} style={{ width: 200 }} onChange={e => this.save(dataIndex, e)}>
          {categories.map(category => <Option key={`category_${category.key}`} value={category.name}>{category.name}</Option>)}
        </Select>)}
      </Form.Item>
    }

    return editing ? (
      formItem
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      handleError,
      children,
      isEditable,
      isReset,
      loadingIndustry,
      loadingCategory,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

export {
  EditableFormRow,
  EditableCell,
}
